const ACTIONS = {
    JOIN: 'join',
    JOINED: 'joined',
    DISCONNECTED: 'disconnected',
    CODE_CHANGE: 'code-change',
    SYNC_CODE: 'sync-code',
    LEAVE: 'leave',
    LANGUAGE_CHANGE: 'language-change',

    // Voice Chat Events
    VOICE_JOIN: 'voice:join',
    VOICE_JOINED: 'voice:joined',
    VOICE_USERS: 'voice:users',
    VOICE_OFFER: 'voice:offer',
    VOICE_ANSWER: 'voice:answer',
    VOICE_ICE: 'voice:ice',
    VOICE_LEAVE: 'voice:leave',
    VOICE_LEFT: 'voice:left',

    // Role & Permissions Events
    ROOM_ROLE: 'room-role',
    PARTICIPANTS_UPDATED: 'participants-updated',
    CHANGE_ROLE: 'change-role',
    ROLE_UPDATED: 'role-updated',
    KICK_USER: 'kick-user',
    KICKED: 'kicked',
    TRANSFER_OWNERSHIP: 'transfer-ownership',
    OWNERSHIP_TRANSFERRED: 'ownership-transferred',

    // Chat Events
    SEND_MESSAGE: 'send-message',
    NEW_MESSAGE: 'new-message',
    LOAD_CHAT_HISTORY: 'load-chat-history',
    CHAT_HISTORY: 'chat-history',
    TYPING_START: 'typing-start',
    TYPING_STOP: 'typing-stop',
    USER_TYPING: 'user-typing',
    USER_STOPPED_TYPING: 'user-stopped-typing',
};

export default ACTIONS;
